import Checkbox from '../../common/components/Checkbox.js'
import {debouncedSaveUserSettings, userSettingSelector} from '../../data/me.js'
import {useSelector} from '../../store.js'

export function autoCalculateOrderTotalsSelector(state) {
  return userSettingSelector(state, {
    setting: 'auto_calculate_order_totals',
    defaultValue: true,
  })
}

export default function AutoCalculateOrderTotalsCheckbox() {
  const autoCalculateOrderTotals = useSelector(autoCalculateOrderTotalsSelector)

  return (
    <Checkbox
      label="Automatically Calculate Financial Totals"
      id="auto_calculate_order_totals"
      checked={autoCalculateOrderTotals}
      onChange={(auto_calculate_order_totals) => {
        debouncedSaveUserSettings({
          auto_calculate_order_totals,
        })
      }}
    />
  )
}
